var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoCleverCubo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 760 750",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M600 140 300 320l80 40 300-180zM490 70 180 250l80 50 310-180zM380 10 70 190l80 40L460 50",
    fill: "#c72524",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M470 700V340l-80 50v350zm120-70V270l-80 50v360zm110-70V200l-80 50v360zm-330-80L60 300v-90l300 180zm0 130L60 430V330l300 180zm0 120L60 550v-90l300 180",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoCleverCubo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-clever-cubo.14eacf686929c754674792d764b75fec.svg";